import React, { useState } from 'react'
import { Avatar } from 'antd'
import { CommonUtility } from 'utility'
import styled from 'styled-components'
import { FlexRow } from './Common'
import { useNavigate } from 'react-router-dom'

export const AppAvatar = ({
  url,
  title,
  bgColor = 'bg-gray-300',
  textColor = 'text-white',
}) => {
  const [imageError, setImageError] = useState(false)

  const handleImageError = () => {
    setImageError(true)
  }

  return (
    <>
      {url && !imageError ? (
        <Avatar
          src={url}
          size={25}
          onError={handleImageError}
          className="rounded-full shadow-md"
        />
      ) : (
        <Avatar
          size={25}
          className={`flex items-center justify-center ${bgColor} ${textColor} rounded-full shadow-md`}
          style={{ fontSize: '12px' }}
        >
          {CommonUtility.getInitials(title)}
        </Avatar>
      )}
    </>
  )
}

const ArtistName = styled.span`
  margin-bottom: 0;
  margin-left: 10px;
  font-size: 14px;
  color: #1a1a1a;
  font-weight: 600;
  @media (max-width: 1350px) {
  font-size:12px;
  }
}
`

export const UserAvatarWithName = ({
  forViewer,
  id,
  url,
  title,
  size = 40,
  onClose,
}) => {
  const navigate = useNavigate()
  return (
    <div
      style={{ cursor: 'pointer', display: 'inline-block' }}
      onClick={() => {
        if (id) {
          if (forViewer) {
            navigate(`/app/manage-viewers/viewers-detail/${id}`)
            if (onClose) {
              onClose()
            }
          } else {
            navigate(`/app/manage-creators/creators-detail/${id}`)
            if (onClose) {
              onClose()
            }
          }
        }
      }}
    >
      <FlexRow className="align-items-center">
        <AppAvatar title={title} url={url} size={size} />
        <ArtistName>{CommonUtility.toTitleCase(title || '')}</ArtistName>
      </FlexRow>
    </div>
  )
}
